import React, { useEffect, useState } from "react";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import {
  all_routes,
  nationalPermission,
  superPermission,
  distPermission,
  finPermission,
  retPermission,
  matPermission,
} from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import {
  createEmployee,
  getAllEmployee,
  updateEmployee,
} from "../../../apis/employees";
import EmpSuccess from "../employees/employeeSuccess";
import { ChangeStatus, uploadFile } from "../../../apis/auth";
import Select from "react-select";
import CommonSearch from "../commonSearch";
import { errorAlert, successAlert } from "../../../style/scss/utils/Alerts";
import { Moment } from "moment";
import {
  getAllNationals,
  getAllNationalsDistributor,
  getAllNationalsFinancer,
  getAllNationalsRetailer,
  getAllNationalsSuper_Distributor,
} from "../../../apis/nationals";
import Newloader from "../employees/loader";
import { formatDate } from "../../../environment";
type PasswordField = "password" | "confirmPassword";

const StaffList = () => {
  const initialValues = {
    full_name: "",
    user_name: "",
    email: "",
    password: "",
    confirm_password: "",
    phone_number: "",
    about: "",
    geo_location: "",
  };
  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;
  const addressState = {
    addressLine: "",
    city: "",
    states: "",
    country: "",
    pincode: "",
  };
  const [address, setAddress] = useState(addressState);
  const { city, states, country, pincode, addressLine } = address;
  const [plans, setPlans] = useState<any>();
  const [type, setType] = useState<any>();
  const [routePermit, setRoutePermit] = useState<any>();
  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [filteredData, setFilteredData] = useState<EmployeeData[]>([]);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [image, setImage] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [formData, setFormData] = useState(initialValues);
  const [selectedNatOption, setSelectedNatOption] = useState<any>();
  const [finSelectedOption, setFinSelectedOption] = useState<any>();
  const [departFin, setDepartFin] = useState<any>([]);
  const [filteredOptions, setFilteredOptions] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<any>(false);
  const [routes, setRoutes] = useState<any>();
  const [userId, setUserID] = useState<any>();
  const allOptions = [
    { value: "national", label: "National" },
    { value: "super_distributor", label: "Super Distributor" },
    { value: "distributor", label: "Distributor" },
    { value: "financer", label: "Financer" },
    { value: "retailer", label: "Retailer" },
  ];

  const natOptions = [
    { value: "super_distributor", label: "Super Distributor" },
    { value: "distributor", label: "Distributor" },
    { value: "financer", label: "Financer" },
    { value: "retailer", label: "Retailer" },
  ];
  const userInformation = JSON.parse(sessionStorage.getItem("info"));

  const sup_dist_options = [{ value: "distributor", label: "Distributor" }];
  const dist_options = [
    { value: "financer", label: "Financer" },
    { value: "retailer", label: "Retailer" },
  ];
  const fin_options = [{ value: "retailer", label: "Retailer" }];

  const filterdOption = (data: any) => {
    switch (data) {
      case "master":
        setFilteredOptions(allOptions);
        break;
      case "national":
        setFilteredOptions(natOptions);
        break;
      case "super_distributer":
        setFilteredOptions(sup_dist_options);
        break;
      case "distributer":
        setFilteredOptions(dist_options);
        break;
      case "financer":
        setFilteredOptions(fin_options);
        break;
      default:
        return;
    }
  };
  const filterdRoutes = (data: any) => {
    switch (data) {
      case "master":
        setRoutePermit(matPermission);
        break;
      case "national":
        setRoutePermit(nationalPermission);
        break;
      case "super_distributer":
        setRoutePermit(superPermission);
        break;
      case "distributer":
        setRoutePermit(distPermission);
        break;
      case "financer":
        setRoutePermit(finPermission);
        break;
      case "retailer":
        setRoutePermit(retPermission);
        break;
      default:
        return;
    }
  };

  const handleNatSelect = (option: any | null) => {
    setSelectedNatOption(option || undefined);
    setSelectedOption(undefined);
    setFinSelectedOption(undefined);
    filterApiCalls(option);
  };

  const filterApiCalls = (option: any) => {
    switch (option.value) {
      case "national":
        fetchAllNationals();
        break;
      case "super_distributor":
        fetchAllSuperDistributors();
        break;
      case "distributor":
        fetchAllDistributors();
        break;
      case "financer":
        fetchAllFinancers();
        break;
      case "retailer":
        fetchAllRetailers();
        break;
      default:
        return;
    }
  };

  const fetchAllNationals = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationals(data);
    setDepartFin(
      response.data.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };
  const fetchAllSuperDistributors = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsSuper_Distributor(data);
    const filteredData = response?.data?.superDistributorData;
    const filteredResponse =
      type === "super_distributer"
        ? filteredData?.filter((ele: any) => {
          const types = sessionStorage.getItem("info");
          const parsedData = JSON.parse(types);
          const id = parsedData.id;
          return Number(ele.id) === Number(id);
        })
        : filteredData;
    setDepartFin(
      filteredResponse.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };
  const fetchAllDistributors = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsDistributor(data);
    const filteredData = response?.data?.distributorData;
    setDepartFin(
      filteredData.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };

  const fetchAllFinancers = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsFinancer(data);
    const newResponse = response?.data?.financerAllData;
    setDepartFin(
      newResponse?.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };
  const fetchAllRetailers = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsRetailer(data);
    const newResponse = response?.data?.retailerAllData;
    setDepartFin(
      newResponse?.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };

  const handleFinSelect = (option: any | null) => {
    setFinSelectedOption(option || undefined);

    const newResponse = allEmployeeData.filter((ele, i) => {
      return Number(ele.allDetails.user_id) === Number(option?.value);
    });
    setFilteredData(newResponse);
  };

  const {
    full_name,
    user_name,
    email,
    password,
    confirm_password,
    phone_number,
  } = formData;

  const handleSelect = (option: any | null) => {
    setSelectedOption(option || undefined);
  };
  const paymentType = [
    { value: "Select", label: "Select" },
    { value: "employee", label: "Employee" },
    { value: "visitor", label: "Visitor" },
  ];
  const retType = [
    { value: "Select", label: "Select" },
    { value: "sales-team", label: "Sales Team" },
  ];
  const financerType = [
    { value: "Select", label: "Select" },
    { value: "manager", label: "Manager" },
    { value: "verfication_person", label: "Verfication Person" },
    { value: "payment_collector", label: "Payment Collector" },
  ];

  const filteredFinancerType = plans
    ? financerType.filter((option) => {
      if (
        (option.value === "payment_collector" &&
          plans.payment_collector > 0) ||
        (option.value === "manager" && plans.total_manager > 0) ||
        (option.value === "verfication_person" && plans.verified_person > 0)
      ) {
        return false;
      }
      return true;
    })
    : [];

  const optionSelect =
    type === "financer"
      ? financerType
      : type === "retailer"
        ? retType
        : paymentType;
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddressChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setAddress({ ...address, [name]: value });
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; // Optional chaining to handle undefined cases

    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }

      setError("");
      setImage(file);
      const formData = new FormData();
      formData.append("image", file);
      const response = await uploadFile(formData);
      if (response.status === true) {
        setImageUrl(response.data.image);
      }
    }
  };

  const handleCancel = () => {
    setFormData(initialValues);
    setAddress(addressState);
    setIsEdit(false);
    setImage(null);
    setError("");
  };

  type EmployeeResponse = {
    user_info: any;
    address: string;
    profile_pic: any;
    full_name: string;
    Image: string;
    CurrentRole: string;
    email: string;
    phone_number: string;
    Designation: string;
    createdAt: string;
    Status: string;
    id: any;
  };

  type EmployeeData = {
    key: number;
    Name: string;
    Image: string;
    CurrentRole: string;
    Email: string;
    Phone: string;
    Designation: string;
    JoiningDate: string;
    Status: string;
    allDetails: any;
    id: any;
  };
  const [loader, setLoader] = useState(false);
  const fetchAllEmployees = async () => {
    setLoader(true);
    try {
      const data = {
        user_id: userInformation.id,
        user_type: userInformation.type,
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
      };
      const response = await getAllEmployee(data);
      const employeeData = response?.data?.map(
        (item: EmployeeResponse, i: number) => ({
          key: `${i + 1}`,
          id: item.id || "--",
          JoiningDate: formatDate(item.createdAt),
          // CurrentRole: item.CurrentRole || "--",
          Name: item.full_name ? item.full_name : "--",
          Email: item.email || "--",
          Phone: item.phone_number || "--",
          address: (() => {
            try {
              const parsed = JSON.parse(item.address);
              return `${parsed.addressLine || ""}, ${parsed.city || ""}, ${parsed.states || ""
                }, ${parsed.country || ""} - ${parsed.pincode || ""}`;
            } catch {
              return "--";
            }
          })(),
          Image: item.profile_pic ? item.profile_pic : "--",
          Designation: item.Designation || "--",
          Status: item.user_info.status || "--",
          allDetails: item,
        })
      );
      setEmployeeData(employeeData || []);
      setFilteredData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoader(false);
    }
  };
  const [retPlans, setRetPlans] = useState();

  useEffect(() => {
    const type = sessionStorage.getItem("info");
    const fetchPlanData = sessionStorage.getItem("plan");
    try {
      if (type) {
        const parsedData = JSON.parse(type);
        if (parsedData) {
          setType(parsedData?.type);
          filterdOption(parsedData?.type);
          filterdRoutes(parsedData?.type);
        }
      }
      if (fetchPlanData) {
        const parsedData =
          fetchPlanData && fetchPlanData !== "undefined"
            ? JSON.parse(fetchPlanData)
            : [];
        setPlans(parsedData);
      }

      if (fetchPlanData) {
        const parsedTypeData = JSON.parse(type);
        if (parsedTypeData?.type === "financer") {
          const parsedData = JSON.parse(fetchPlanData);
          const newData = JSON.parse(parsedData[0]?.discription);
          setPlans(newData);
        }
      }
      if (fetchPlanData) {
        const parsedTypeData = JSON.parse(type);
        if (parsedTypeData?.type === "retailer") {
          const parsedData = JSON.parse(fetchPlanData);
          const newData = JSON.parse(parsedData[0]?.discription);
          setRetPlans(newData?.total_retailer_sales_team);
        }
      }
    } catch (error) {
      console.error(error, "error");
    }
    fetchAllEmployees();
  }, [state]);

  const [newStatus, setNewStatus] = useState<any>(null);
  const handleChangeStatus = (data: { id: string; status: string }) => {
    const payload = {
      id: data.id,
      status: data.status,
    };
    setNewStatus(payload);
  };
  const handleSubmitStatus = async (event: any) => {
    event.preventDefault();
    try {
      const payload = {
        status: newStatus?.status,
      };
      const response = await ChangeStatus(newStatus?.id, payload);
      if (response.status === true) {
        successAlert("success", `User Status Changed to ${newStatus?.status}`);
        fetchAllEmployees();
        setNewStatus(null);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };

  const [selectedEmployee, setSelectedEmployee] = useState<any>();

  const mapRecordToFormData = (record: any) => {
    return {
      full_name: record.allDetails.full_name || "",
      user_name: record.Name || "",
      email: record.allDetails.email || "",
      password: "",
      confirm_password: "",
      phone_number: record.allDetails.phone_number || "",
      about: "",
      geo_location: record.allDetails.geo_location || "",
      permissionRoute: record?.allDetails?.user_info?.permitted_routes || "",
      userData: record?.allDetails?.user_info,
    };
  };

  const mapRecordToaddress = (record: any) => {
    const parsedAddress = JSON.parse(record.allDetails.address || {});
    return {
      addressLine: parsedAddress.addressLine,
      city: parsedAddress.city,
      states: parsedAddress.states,
      country: parsedAddress.country,
      pincode: parsedAddress.pincode,
    };
  };
  const mapSelectOption = (record: any) => {
    return {};
  };

  const handleEditClick = (record: any) => {
    const mappedData = mapRecordToFormData(record);
    const addressData = mapRecordToaddress(record);
    const permissionRoutes = JSON.parse(mappedData?.permissionRoute) || [];

    const selectedRoutes = permissionRoutes?.map((r: any) => r.route);
    const allRoutes =
      type && routePermit
        ? Object.values(routePermit).map((route) => ({
          route: String(route),
          selected: selectedRoutes.includes(route),
        }))
        : [];
    setUserID(mappedData);
    setRoutes(allRoutes);
    setFormData(mappedData);
    setAddress(addressData);
    setIsEdit(true);
  };

  const columns = [
    {
      title: "Sr No",
      dataIndex: "key",
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (_: any, record: EmployeeData) => (
        <div>{formatDate(record?.allDetails?.createdAt) || "--"}</div>
      ),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div
            className="avatar avatar-md"
            data-bs-toggle="modal"
            data-bs-target="#view_details"
          >
            <img
              src={`${record.Image}`}
              className="img-fluid rounded-circle"
              alt="Employee"
            />
          </div>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <div>{record.Name}</div>
            </p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Email.localeCompare(b.Email),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Parent Name",
      dataIndex: "address",
      render: (text: string, record: EmployeeData) => {
        let parentName = "-";
        if (record?.allDetails?.employee_model_type === "retailer") {
          return record?.allDetails?.retailer?.company_name || "-";
        } else if (record?.allDetails?.employee_model_type === "financer") {
          return record?.allDetails?.financer?.company_name || "-";
        } else if (
          record?.allDetails?.employee_model_type === "super_distributer"
        ) {
          return record?.allDetails?.super_distributer?.company_name || "-";
        } else if (record?.allDetails?.employee_model_type === "distributer") {
          return record?.allDetails?.distributer?.company_name || "-";
        } else if (record?.allDetails?.employee_model_type === "national") {
          return record?.allDetails?.national?.company_name || "-";
        }
        return (
          <div className="ms-2">
            <p className="text-dark mb-0">
              <div>{parentName}</div>
            </p>
          </div>
        );
      },
    },
    {
      title: "Owner Name",
      dataIndex: "address",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{record?.allDetails?.created_by?.type}</div>
          </p>
        </div>
      ),
    },
    // {
    //   title: "Joining Date",
    //   dataIndex: "JoiningDate",
    //   render: (_: any, record: EmployeeData) => (
    //     <div className="ms-2">
    //       <p className="text-dark mb-0">
    //         <div>{record.JoiningDate}</div>
    //       </p>
    //     </div>
    //   ),
    // },
    // {
    //   title: "Status",
    //   dataIndex: "Status",
    //   render: (text: string, record: EmployeeData) => (
    //     <span className="dropdown">
    //       <Link
    //         to="#"
    //         className={`badge  btn btn-white ${
    //           text === "Active" ? "badge-success" : "badge-danger"
    //         } d-inline-flex align-items-center badge-xs`}
    //         data-bs-toggle="dropdown"
    //       >
    //         <i className="ti ti-point-filled me-1" />
    //         {record?.allDetails?.user?.status}
    //       </Link>
    //       <ul className="dropdown-menu dropdown-menu-end p-3">
    //         <li>
    //           <div
    //             className="dropdown-item rounded-1"
    //             data-bs-toggle="modal"
    //             data-bs-target="#status_modal"
    //             onClick={() =>
    //               handleChangeStatus({
    //                 id: record.allDetails.user_id,
    //                 status: "Active",
    //               })
    //             }
    //           >
    //             Active
    //           </div>
    //         </li>
    //         <li>
    //           <div
    //             className="dropdown-item rounded-1"
    //             data-bs-toggle="modal"
    //             data-bs-target="#status_modal"
    //             onClick={() =>
    //               handleChangeStatus({
    //                 id: record.allDetails.user_id,
    //                 status: "InActive",
    //               })
    //             }
    //           >
    //             InActive
    //           </div>
    //         </li>
    //       </ul>
    //     </span>
    //   ),
    //   sorter: (a: EmployeeData, b: EmployeeData) =>
    //     a.Status.localeCompare(b.Status),
    // },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: EmployeeData) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#add_employee"
            onClick={() => handleEditClick(record)}
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to={`/viewstaff?EmployeeData=${encodeURIComponent(
              JSON.stringify(record.id)
            )}`}
          >
            <i className="ti ti-eye" />
          </Link>
        </div>
      ),
    },
  ];

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const mtIdString = sessionStorage.getItem("info");
  let mtId: { id: string; user_id: string; type: string } | null = null;
  if (mtIdString) {
    try {
      mtId = JSON.parse(mtIdString);
    } catch (error) {
      console.error("Failed to parse sessionStorage info:", error);
    }
  }

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(allEmployeeData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Staff");
    XLSX.writeFile(workbook, "Staff List.xlsx");
  };

  const setNewRoutes = () => {
    const data =
      type && routePermit
        ? Object.values(routePermit).map((route) => ({
          route: String(route),
          selected: false,
        }))
        : [];
    setRoutes(data);
  };
  useEffect(() => {
    setNewRoutes();
  }, [routePermit, type]);
  // Handle checkbox change
  // const handleCheckboxChange = (index, type) => {
  //   setRoutes((prevRoutes) =>
  //     prevRoutes.map((item, i) =>
  //       i === index ? { ...item, [type]: !item[type] } : item
  //     )
  //   );
  // };

  // Handle select checkbox change
  const handleSelectChange = (index) => {
    setRoutes((prevRoutes) =>
      prevRoutes.map((item, i) =>
        i === index ? { ...item, selected: !item.selected } : item
      )
    );
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    if (password !== confirm_password) {
      errorAlert("password and confirm_password should be the same");
      return;
    }
    const selectedRoutes = routes
      .filter((item) => item.selected)
      .map((item) => ({
        route: item.route,
        // read: item.read,
        // write: item.write,
      }));
    setLoader(true);
    const master_Id = mtId?.id;
    const type = mtId?.type;
    const payload = {
      address: address,
      email: formData.email,
      gst_no: "",
      full_name: formData.full_name,
      password: formData.password,
      phone_number: formData.phone_number,
      // prefix_code: formData.prefix_code,
      user_name: formData.user_name,
      geo_location: formData.geo_location,
      profile_pic: imageUrl,
      user_id: master_Id,
      type: selectedOption?.value,
      permitted_routes: selectedRoutes,
      national_id: type === "national" ? master_Id : "",
      super_distributor_id: type === "super_distributer" ? master_Id : "",
      distributor_id: type === "distributer" ? master_Id : "",
      financer_id: type === "financer" ? master_Id : "",
      retailer_id: type === "retailer" ? master_Id : "",
      employeeType: type,
    };

    const updatePayload = {
      address: address,
      email: formData.email,
      full_name: formData.full_name,
      phone_number: formData.phone_number,
      geo_location: formData.geo_location,
      profile_pic: imageUrl,
      user_id: master_Id,
      type: selectedOption?.value,
      permitted_routes: selectedRoutes,
    };
    try {
      if (isEdit) {
        const response = await updateEmployee({
          data: updatePayload,
          id: userId?.userData?.id,
          vendor_id: userId?.userData?.vendor_id,
        });
        if (response.status === true) {
          setSuccessCreation(true);
          fetchAllEmployees();
          setAddress(addressState);
          setFormData(initialValues);
        }
      } else {
        const response = await createEmployee(payload);
        if (response.status === true) {
          setSuccessCreation(true);
          fetchAllEmployees();
          setAddress(addressState);
          setFormData(initialValues);
        }
      }
    } catch (error) {
      errorAlert("error", `${error?.response?.data?.message}`);
    } finally {
      setLoader(false);
    }
    // action={all_routes.employeeList}
  };
  const [openPermissions, setOpenPermissions] = useState(false);
  const generateNext = () => {
    let requiredFields = [
      "email",
      "full_name",
      "password",
      "phone_number",
      "user_name",
    ];

    const isEditBool = isEdit === true || isEdit === "true";

    if (isEditBool) {
      requiredFields = requiredFields.filter((field) => field !== "password");
    }

    const emptyFields = requiredFields.filter((field) => {
      const value = formData[field as keyof typeof formData];
      if (typeof value === "string") {
        return value.trim() === "";
      }
      return value === undefined || value === null || value === "";
    });

    if (emptyFields.length > 0) {
      errorAlert(
        `Please fill out the required fields: ${emptyFields.join(", ")}`
      );
      return;
    }

    setOpenPermissions(true);
  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>

              <div className="mb-2">
                {(type === "retailer" &&
                  Number(retPlans) > (filteredData?.length || 0)) ||
                  (type === "financer" &&
                    Number(plans?.total_staff) > (filteredData?.length || 0)) ||
                  type === "national" ||
                  type === "super_distributer" ||
                  type === "distributer" ? (
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#add_employee"
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add New Employee
                  </Link>
                ) : null}
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <CommonSearch
                    allEmployeeData={allEmployeeData}
                    setFilteredData={setFilteredData}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent Role</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {selectedNatOption
                        ? selectedNatOption.label
                        : "Select Role"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {filteredOptions?.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleNatSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent User</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {finSelectedOption
                        ? finSelectedOption.label
                        : "Select User"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {departFin.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleFinSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {/* <li>
                        <div
                          onClick={exportToPDF}
                          className="btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </div>
                      </li> */}
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {loader ? (
              <div className="card-body p-0">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    height: "30vh",
                    alignItems: "center",
                  }}
                >
                  <Newloader />
                </div>
              </div>
            ) : (
              <div className="card-body p-0">
                {filteredData && filteredData.length > 0 ? (
                  <Table
                    dataSource={filteredData}
                    columns={columns}
                    Selection={true}
                  // rowSelection={{ type: "checkbox" }}
                  />
                ) : (
                  <p className="custom-cal-react " style={{ padding: "15px" }}>
                    No Data Found
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Edit Functionality */}
      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Employee</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form
            // onSubmit={handleSubmit}
            >
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${!openPermissions ? "active" : ""}`}
                      // id="info-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#basic-info"
                      type="button"
                      // role="tab"
                      aria-selected="true"
                      onClick={() => setOpenPermissions(!openPermissions)}
                    >
                      Basic Information
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${openPermissions ? "active" : ""}`}
                      // id="address-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#permission"
                      type="button"
                      // role="tab"
                      aria-selected="false"
                    >
                      Permissions
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                {!openPermissions && (
                  <div
                  // className="tab-pane fade show active"
                  // id="basic-info"
                  // role="tabpanel"
                  // aria-labelledby="info-tab"
                  // tabIndex={0}
                  >
                    <div className="modal-body pb-0 ">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                            <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                              <i className="ti ti-photo text-gray-2 fs-16" />
                            </div>
                            <div className="profile-upload">
                              <div className="mb-2">
                                <h6 className="mb-1">Upload Profile Image</h6>
                                <p className="fs-12">
                                  Image should be below 4 MB
                                </p>
                                {error && (
                                  <p className="text-danger">{error}</p>
                                )}
                              </div>
                              <div className="profile-uploader d-flex align-items-center">
                                <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                  Upload
                                  <input
                                    type="file"
                                    className="form-control image-sign"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                  />
                                </div>
                                <Link
                                  to="#"
                                  className="btn btn-light btn-sm"
                                  onClick={handleCancel}
                                >
                                  Cancel
                                </Link>
                              </div>
                              {image && (
                                <div className="mt-3">
                                  <p>Preview:</p>
                                  <img
                                    src={URL.createObjectURL(image)}
                                    alt="Profile Preview"
                                    className="img-thumbnail"
                                    style={{
                                      maxWidth: "150px",
                                      maxHeight: "150px",
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Full Name <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="full_name"
                              required
                              value={full_name}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Email <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="email"
                              required
                              name="email"
                              value={email}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Phone Number{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="number"
                              required
                              name="phone_number"
                              value={phone_number}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              User Name <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="user_name"
                              required
                              value={user_name}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                        </div>

                        {!isEdit && (
                          <>
                            <div className="col-md-6">
                              <div className="mb-3 ">
                                <label className="form-label">
                                  Password{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <div className="pass-group">
                                  <input
                                    type={
                                      passwordVisibility.password
                                        ? "text"
                                        : "password"
                                    }
                                    className="pass-input form-control"
                                    name="password"
                                    required
                                    value={password}
                                    onChange={handleChange}
                                  />
                                  <span
                                    className={`ti toggle-passwords ${passwordVisibility.password
                                      ? "ti-eye"
                                      : "ti-eye-off"
                                      }`}
                                    onClick={() =>
                                      togglePasswordVisibility("password")
                                    }
                                  ></span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3 ">
                                <label className="form-label">
                                  Confirm Password{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <div className="pass-group">
                                  <input
                                    type={
                                      passwordVisibility.confirmPassword
                                        ? "text"
                                        : "password"
                                    }
                                    className="pass-input form-control"
                                    name="confirm_password"
                                    required
                                    value={confirm_password}
                                    onChange={handleChange}
                                  />
                                  <span
                                    className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                      ? "ti-eye"
                                      : "ti-eye-off"
                                      }`}
                                    onClick={() =>
                                      togglePasswordVisibility(
                                        "confirmPassword"
                                      )
                                    }
                                  ></span>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {!isEdit && (
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Select Employee Type
                              </label>
                              <Select
                                classNamePrefix="react-select"
                                className="select"
                                options={optionSelect}
                                value={selectedOption}
                                required
                                onChange={handleSelect}
                                placeholder="Select Employee Type"
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Address Line{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="addressLine"
                              required
                              value={addressLine}
                              onChange={handleAddressChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              City <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              required
                              name="city"
                              value={city}
                              onChange={handleAddressChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              State <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="states"
                              required
                              value={states}
                              onChange={handleAddressChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Country <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="country"
                              required
                              value={country}
                              onChange={handleAddressChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              PinCode <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="pincode"
                              required
                              value={pincode}
                              onChange={handleAddressChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-2"
                        data-bs-dismiss="modal"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => generateNext()}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
                {openPermissions && (
                  <div>
                    <div className="modal-body">
                      <div className="table-responsive border rounded">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Select</th>
                              <th>Route</th>
                            </tr>
                          </thead>
                          <tbody>
                            {type &&
                              routes?.map((item, index) => (
                                <tr key={item.route}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={item.selected}
                                      onChange={() => handleSelectChange(index)}
                                    />
                                  </td>
                                  <td>{item.route}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-outline-light border me-2"
                          data-bs-dismiss="modal"
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleSubmit}
                          data-bs-dismiss="modal"
                          className="btn btn-primary"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="status_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Change Status</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitStatus}>
              <div
                className="contact-grids-tab"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <h3>Are you sure? you want to {newStatus?.status} this user</h3>
                <button
                  type="button"
                  className="btn btn-outline-light border me-2"
                  data-bs-dismiss="modal"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default StaffList;
